export var getStyles = function (props) {
    var className = props.className, width = props.width, height = props.height, theme = props.theme;
    return {
        root: [
            theme.fonts.medium,
            'ms-DonutChart',
            {
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
            },
            className,
        ],
        chart: {
            width: width,
            height: height,
            boxSizing: 'content-box',
            overflow: 'visible',
            alignmentAdjust: 'center',
            display: 'block',
        },
        legendContainer: {
            paddingTop: '16px',
            width: width + "px",
        },
    };
};
//# sourceMappingURL=DonutChart.styles.js.map